import { Bank, BankSchema } from '@hero/schema';
import { API } from '..';
import { z } from 'zod';

const schema = BankSchema.model.pick({
  _id: true,
  IBAN: true,
  accountImage: true,
  bankName: true,
  preference: true,
  accountName: true,
});

//* Create
export const bankCreateAPISchema = schema.omit({ _id: true });
export type BankCreateAPI = API<z.infer<typeof bankCreateAPISchema>, Bank>;

//* Update
export const bankUpdateAPISchema = schema.partial().required({ _id: true });
export type BankUpdateAPI = API<z.infer<typeof bankUpdateAPISchema>, Bank>;

//* Get Primary Bank
export const bankGetPrimaryAPISchema = schema.partial().required({ _id: true });
export type BankGetPrimaryAPI = API<z.infer<typeof bankGetPrimaryAPISchema>, Bank>;
